import { render, staticRenderFns } from "./ReferralList.vue?vue&type=template&id=529aa9fd&scoped=true&"
import script from "./ReferralList.vue?vue&type=script&lang=js&"
export * from "./ReferralList.vue?vue&type=script&lang=js&"
import style0 from "./ReferralList.vue?vue&type=style&index=0&id=529aa9fd&lang=scss&scoped=true&"
import style1 from "./ReferralList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529aa9fd",
  null
  
)

export default component.exports